import BottomNav from './BottomNav'
import { IconHome } from './icons'

/**
 * Terms of Use page.
 * Rendered as an in-app screen (via gameState 'terms') and as a public URL
 * (/terms) — when accessed via URL, onBack is undefined and the BottomNav
 * is hidden (same conditional as the old floating back arrow).
 */
export default function TermsPage({ onBack }) {
  return (
    <div className="legal-page">
      <div className="screen-content legal-page__content">
        <h1 className="legal-page__title">Terms of Use</h1>
        <p className="legal-page__updated">Last Updated: May 2026</p>

        <p className="legal-page__intro">
          Welcome to Action! The Movie Game ("Action!", "the App", "we", "our", or "us"). By
          accessing or using Action! The Movie Game — whether through our website, iOS app, or
          tvOS app — you agree to be bound by these Terms of Use. If you do not agree, please
          do not use the App.
        </p>

        <h2 className="legal-page__section">1. Acceptance of Terms</h2>
        <p>
          By creating an account or using the App in any way, you confirm that you are at least
          13 years of age and agree to these Terms of Use and our Privacy Policy.
        </p>

        <h2 className="legal-page__section">2. Description of Service</h2>
        <p>
          Action! The Movie Game is a movie connection game in which players connect actors
          through shared film appearances. The App offers single player, multiplayer, and party
          game modes. Gameplay requires tickets, which are earned through daily play or
          purchased via in-app purchase.
        </p>

        <h2 className="legal-page__section">3. User Accounts</h2>
        <p>
          You are responsible for maintaining the confidentiality of your account credentials
          and for all activity that occurs under your account. You agree to provide accurate
          information when creating your account and to notify us immediately of any
          unauthorized use.
        </p>

        <h2 className="legal-page__section">4. Ticket Economy &amp; In-App Purchases</h2>
        <ul className="legal-page__list">
          <li>Tickets are the in-app currency used to play games in Action!</li>
          <li>Tickets can be earned for free through daily play or purchased via in-app purchase</li>
          <li>All purchases are final and non-refundable except where required by applicable law</li>
          <li>Tickets have no real-world monetary value and cannot be exchanged for cash</li>
          <li>We reserve the right to modify ticket pricing, earning rates, or game costs at any time</li>
          <li>In-app purchases are processed by Apple (iOS) or Google (Android) and are subject to their respective terms</li>
        </ul>

        <h2 className="legal-page__section">5. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul className="legal-page__list">
          <li>Use the App for any unlawful purpose</li>
          <li>Attempt to gain unauthorized access to any part of the App or its infrastructure</li>
          <li>Reverse engineer, decompile, or otherwise attempt to extract the source code of the App</li>
          <li>Use automated tools, bots, or scripts to interact with the App</li>
          <li>Harass, abuse, or harm other users</li>
          <li>Create multiple accounts to circumvent account restrictions or bans</li>
        </ul>

        <h2 className="legal-page__section">6. Intellectual Property</h2>
        <p>
          All content, design, code, and branding associated with Action! The Movie Game is
          the intellectual property of Kevin Turner. You may not reproduce, distribute, or
          create derivative works without express written permission.
        </p>
        <p>
          This product uses the TMDB API but is not endorsed or certified by TMDB. All movie
          and actor data is sourced from The Movie Database (TMDB). Image and metadata rights
          belong to their respective owners.
        </p>

        <h2 className="legal-page__section">7. User-Generated Content</h2>
        <p>
          By uploading a profile avatar or any other content to the App, you grant us a
          non-exclusive, royalty-free license to use, display, and store that content solely
          for the purpose of operating the App.
        </p>

        <h2 className="legal-page__section">8. Termination</h2>
        <p>
          We reserve the right to suspend or terminate your account at any time for violation
          of these Terms or for any other reason at our sole discretion. Upon termination, your
          tickets and account data will be forfeited.
        </p>

        <h2 className="legal-page__section">9. Disclaimers</h2>
        <p>
          The App is provided "as is" without warranties of any kind. We do not guarantee
          uninterrupted or error-free service. We are not responsible for any loss of data,
          tickets, or progress due to technical issues.
        </p>

        <h2 className="legal-page__section">10. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Kevin Turner shall not be liable for any
          indirect, incidental, special, or consequential damages arising from your use of
          the App.
        </p>

        <h2 className="legal-page__section">11. Changes to Terms</h2>
        <p>
          We may update these Terms at any time. Continued use of the App after changes are
          posted constitutes your acceptance of the updated Terms.
        </p>

        <h2 className="legal-page__section">12. Contact</h2>
        <p>
          For questions about these Terms, contact us at:{' '}
          <a href="mailto:support@actionthemoviegame.com" className="legal-page__link">
            support@actionthemoviegame.com
          </a>
        </p>

        {onBack && (
          <BottomNav items={[
            { key: 'home', icon: IconHome, label: 'Home', variant: 'primary', onClick: onBack },
          ]} />
        )}
      </div>
    </div>
  )
}
